import { Link, useNavigate } from 'react-router-dom'
import { Button } from '../components/common'

/**
 * Pagina 404 - Not Found
 */
export default function NotFound() {
  const navigate = useNavigate()

  return (
    <div className="container mx-auto px-4 py-16 text-center">
      <div className="max-w-md mx-auto">
        {/* Numero 404 stilizzato */}
        <div className="mb-8">
          <span className="font-display text-9xl text-gold/20">404</span>
        </div>

        {/* Icona */}
        <div className="w-20 h-20 bg-gray-800 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg
            className="w-10 h-10 text-gray-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>

        {/* Testo */}
        <h1 className="font-display text-3xl text-white mb-4">
          Pagina Non Trovata
        </h1>
        <p className="text-gray-400 mb-8">
          Ops! Sembra che ti sia perso tra le strade bianche delle Marche.
          La pagina che stai cercando non esiste.
        </p>

        {/* Azioni */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/">
            <Button variant="primary">
              Torna alla Home
            </Button>
          </Link>
          <Button variant="secondary" onClick={() => navigate(-1)}>
            Torna Indietro
          </Button>
        </div>

        {/* Link rapidi */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <p className="text-sm text-gray-500 mb-4">Oppure visita:</p>
          <div className="flex flex-wrap justify-center gap-4 text-sm">
            <Link to="/locali" className="text-gold hover:text-gold-light transition-colors">
              Tutti i Locali
            </Link>
            <Link to="/come-funziona" className="text-gold hover:text-gold-light transition-colors">
              Come Funziona
            </Link>
            <Link to="/il-club" className="text-gold hover:text-gold-light transition-colors">
              Il Club
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
